<template>
  <div>
    <b-navbar toggleable="md" type="light" variant="light" fixed="top">
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-navbar-brand class="tibetan-text">པུམ་བ་མི་རྟག་བ་ཡིན</b-navbar-brand>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="banner-image-container">
    </div>
    <h4 class="banner-header">Pots are impermanent, nonstick pots doubly so...</h4>
  </div>
</template>

<script>
export default {
  name: 'EmailQuestion',
  props: {
    email: String
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner-image-container {
    background-image: url('../assets/buddha.jpg');
    background-size: cover;
    background-position: center;
    height:500px;
    width:100%;
  }

  .banner-header {
    margin-top: 10px;
    margin-bottom: 20px;
  }
</style>
